export default class RfpsController {
    constructor($state, $ionicScrollDelegate, $stateParams) {
        this.$state = $state;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.disabledx = false;
    }

    init() {
        this.sortOrder = {
            value: 'ISSUE_DATE_ASC',
            field: 'ISSUE_DATE',
            order: 'ASC',
            type: 'ISSUE_DATE',
        };

        this.sortCriteria = [
            {
                value: 'ASSET_CLASS_ASC',
                field: 'ASSET_CLASS',
                order: 'ASC',
                type: 'ASSET_CLASS',
            },
            {
                value: 'ASSET_CLASS_DESC',
                field: 'ASSET_CLASS',
                order: 'DESC',
                type: 'ASSET_CLASS',
            },
            {
                value: 'COUNTRY_ASC',
                field: 'COUNTRY',
                order: 'ASC',
                type: 'COUNTRY',
            },
            {
                value: 'COUNTRY_DESC',
                field: 'COUNTRY',
                order: 'DESC',
                type: 'COUNTRY',
            },
            {
                value: 'DEADLINE_ASC',
                field: 'DEADLINE',
                order: 'ASC',
                type: 'DEADLINE',
            },
            {
                value: 'DEADLINE_DESC',
                field: 'DEADLINE',
                order: 'DESC',
                type: 'DEADLINE',
            },
            {
                value: 'FOCUS_ASC',
                field: 'FOCUS',
                order: 'ASC',
                type: 'FOCUS',
            },
            {
                value: 'FOCUS_DESC',
                field: 'FOCUS',
                order: 'DESC',
                type: 'FOCUS'
            },
            {
                value: 'ISSUE_DATE_ASC',
                field: 'ISSUE_DATE',
                order: 'ASC',
                type: 'ISSUE_DATE',
            },
            {
                value: 'ISSUE_DATE_DESC',
                field: 'ISSUE_DATE',
                order: 'DESC',
                type: 'ISSUE_DATE',
            },
            {
                value: 'REGION_ASC',
                field: 'REGION',
                order: 'ASC',
                type: 'REGION',
            },
            {
                value: 'REGION_DESC',
                field: 'REGION',
                order: 'DESC',
                type: 'REGION',
            },
            {
                value: 'REQUEST_ISSUER_ASC',
                field: 'REQUEST_ISSUER',
                order: 'ASC',
                type: 'REQUEST_ISSUER',
            },
            {
                value: 'REQUEST_ISSUER_DESC',
                field: 'REQUEST_ISSUER',
                order: 'DESC',
                type: 'REQUEST_ISSUER',
            },
            {
                value: 'RESPONDENT_ASC',
                field: 'RESPONDENT',
                order: 'ASC',
                type: 'RESPONDENT',
            },
            {
                value: 'RESPONDENT_DESC',
                field: 'RESPONDENT',
                order: 'DESC',
                type: 'RESPONDENT',
            },
            {
                value: 'STATUS_ASC',
                field: 'STATUS',
                order: 'ASC',
                type: 'STATUS',
            },
            {
                value: 'STATUS_DESC',
                field: 'STATUS',
                order: 'DESC',
                type: 'STATUS',
            },
            {
                value: 'TYPE_ASC',
                field: 'TYPE',
                order: 'ASC',
                type: 'TYPE',
            },
            {
                value: 'TYPE_DESC',
                field: 'TYPE',
                order: 'DESC',
                type: 'TYPE',
            }
        ];

        this.updateDisable = (flag) => {
            this.disabled = flag;
        };

        this.isFilterActive = () => {
            return (
                this.filterIndicationText &&
                this.filterIndicationText.length > 0
            );
        };
    }
}



/** WEBPACK FOOTER **
 ** ./src/app/components/rfps/rfps.controller.js
 **/